<template>
  <div class="dashboard-form">
    <h1>Add Posts</h1>
    <form @submit.prevent="submitHandler">
      <div v-if="imageUpload">
        <img class="img-fluid" :src="imageUpload" width="40%"/>
      </div>
      <div class="form-group">
        <input type="file" @change="processFile($event)" ref="myFileInput" class="form-control" />
        <div v-if="$v.formdata.img.$error">
          <p class="error_label_red" v-if="!$v.formdata.img.required">This input is required.</p>
          <p
            class="error_label_red"
            v-if="this.invalidImg"
          >Image must be in jpg, jpeg or png format.</p>
        </div>
      </div>
      <div class="form-group" :class="{invalid: $v.formdata.title.$error}">
        <label>Title</label>
        <input
          type="text"
          v-model.trim="$v.formdata.title.$model"
          class="form-control"
          placeholder="Title"
        />
        <div v-if="$v.formdata.title.$error">
          <p class="error_label_red" v-if="!$v.formdata.title.required">This input is required.</p>
        </div>
      </div>
      <div class="form-group">
        <label>Slug</label>
        <slug-input
          v-model.trim="$v.formdata.title.$model"
          @change="onSlugChange($event)"
          class="form-control"
          placeholder="Slug"
        ></slug-input>
        <div v-if="$v.formdata.slug.$error">
          <p class="error_label_red" v-if="!$v.formdata.slug.required">This input is required.</p>
          <!-- <p class="error_label_red" v-if="!$v.formdata.slug.unique">Unique.</p> -->
        </div>
      </div>
      <div class="form-group" :class="{invalid: $v.formdata.desc.$error}">
        <label>Description</label>
        <textarea
          type="text"
          v-model.trim="$v.formdata.desc.$model"
          class="form-control"
          placeholder="Description"
        />
        <div v-if="$v.formdata.desc.$error">
          <p class="error_label_red" v-if="!$v.formdata.desc.required">This input is required.</p>
          <p
            class="error_label_red"
            v-if="!$v.formdata.desc.maxLength"
          >Must not be greater than {{ $v.formdata.desc.$params.maxLength.max }} characters.</p>
        </div>
      </div>
      <div class="form-group">
        <label>Content</label>
        <wysiwyg v-model.trim="$v.formdata.content.$model" />
        <div v-if="$v.formdata.content.$error">
          <p class="error_label_red" v-if="!$v.formdata.content.required">This input is required.</p>
          <p
            class="error_label_red"
            v-if="!$v.formdata.content.minLength"
          >Must not be greater than {{ $v.formdata.content.$params.minLength.min }} characters.</p>
        </div>
      </div>
      <div class="form-group">
        <label>Categories</label>
        <v-selectize
          v-model="$v.formdata.categories.$model"
          :options="categories"
          multiple
          placeholder="Select Category"
        />
        <div v-if="$v.formdata.categories.$error">
          <p
            class="error_label_red"
            v-if="!$v.formdata.categories.required"
          >You need to select at lease one.</p>
        </div>
      </div>
      <div class="form-group">
        <label>Tags</label>
        <v-selectize
          v-model="$v.formdata.tags.$model"
          :options="tags"
          multiple
          placeholder="Select Tag"
        />
        <div v-if="$v.formdata.tags.$error">
          <p
            class="error_label_red"
            v-if="!$v.formdata.tags.required"
          >You need to select at lease one.</p>
        </div>
      </div>
      <div class="form-group">
        <label>Ratings</label>
        <v-selectize
          v-model="$v.formdata.rating.$model"
          :options="[1,2,3,4,5]"
          placeholder="Select Ratings"
        />
        <div v-if="$v.formdata.rating.$error">
          <p
            class="error_label_red"
            v-if="!$v.formdata.rating.required"
          >You need to select at lease one.</p>
        </div>
      </div>
      <div class="form-group publish-date">
        <label>Publish Date</label>
        <date-picker v-model="$v.formdata.published_date.$model" valueType="format"></date-picker>
      </div>
      <button type="submit" class="btn btn-primary">Add Post</button>
    </form>
    <div v-if="addpost" class="post_succesfull">Post has been added successfully.</div>
  </div>
</template>

<script>
/* eslint-disable */
import { required, maxLength, minLength } from "vuelidate/lib/validators";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import VSelectize from "@isneezy/vue-selectize";
import "selectize/dist/css/selectize.default.css";

export default {
  data() {
    return {
      selected: "",
      dialog: false,
      error: false,
      invalidImg: false,
      formdata: {
        img: "",
        title: "",
        slug: "",
        desc: "",
        content: "",
        tags: [],
        categories: [],
        rating: "",
        published_date:""
      },
    };
  },
  components: { VSelectize, DatePicker },
  validations: {
    formdata: {
      title: {
        required,
      },
      desc: {
        required,
        maxLength: maxLength(100),
      },
      content: {
        required,
        minLength: minLength(100),
      },
      rating: {
        required,
      },
      img: {
        required,
      },
      tags: {
        required,
      },
      categories: {
        required,
      },
      published_date: {
        required,
      },
      slug: {
        required,
        // isUnique(value) {
        //   // standalone validator ideally should not assume a field is required
        //   if (value === "") return true;

        //   // simulate async call, fail for all logins with even length
        //   return new Promise((resolve, reject) => {
        //     setTimeout(() => {
        //       resolve(typeof value === "string" && value.length % 2 !== 0);
        //     }, 350 + Math.random() * 300);
        //   });
        // },
      },
    },
  },
  computed: {
    tags() {
      let results = this.$store.getters["admin/getTags"];
      if (results) {
        var newArr = results.map(function (val, index) {
          return val.name;
        });
      }
      return newArr;
    },
    categories() {
      let results = this.$store.getters["admin/getCategories"];
      if (results) {
        var newArr = results.map(function (val, index) {
          return val.name;
        });
      }
      return newArr;
    },
    addpost() {
      let status = this.$store.getters["admin/addPostStatus"];
      if (status) {
        this.clearPost();
        this.$store.commit("admin/clearImageUpload");
      }
      return status;
    },
    imageUpload() {
      let imageURL = this.$store.getters["admin/imageUpload"];
      this.formdata.img = imageURL;

      return imageURL;
    },
  },
  methods: {
    submitHandler() {
      this.$v.formdata.$touch();
      if (!this.$v.$invalid) {
        if (this.formdata.content === "") {
          this.error = true;
        } else {
          this.dialog = true;
          this.addPost();
        }
      } else {
        this.error = true;
      }
    },
    dialogOnCancel() {
      this.dialog = false;
    },
    dialogOnConfirm() {
      this.dialog = false;
      this.addPost();
    },
    addPost() {
      this.$store.dispatch("admin/addPost", this.formdata);
    },
    clearPost() {
      this.$v.$reset();
      this.$refs.myFileInput.value = "";
      this.formdata = {
        title: "",
        desc: "",
        slug: "",
        content: "",
        tags: [],
        categories: [],
        rating: "",
        published_date:""
      };
    },
    processFile(event) {
      let file = event.target.files[0];
      if (file.type == "image/jpeg" || file.type == "image/png") {
        this.invalidImg = false;
        this.$store.dispatch("admin/imageUpload", file);
      } else {
        this.invalidImg = true;
      }
    },
    onSlugChange(event) {
      this.formdata.slug = event;
    },
  },
  destroyed() {
    this.$store.commit("admin/clearImageUpload");
  },
  created() {
    this.$store.dispatch("admin/getTag");
    this.$store.dispatch("admin/getCategory");
  },
};
</script>

<style scoped>
@import "~vue-wysiwyg/dist/vueWysiwyg.css";
.input_field.invalid input,
.input_field.invalid select {
  border: 1px solid red;
}
</style>